/**
 * Определяет, запущено ли приложение во Flutter WebView.
 */
export const isMobileWebView = (): boolean => Boolean(window.flutter_inappwebview?.callHandler);
